import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/slide-toggle';

export const TM_SLIDE_TOGGLE_PROVIDER = {
  provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS,
  useValue: { color: 'primary' }
};

export * from './slide-toggle.component';
